import { Outlet } from 'react-router-dom';

const AppLayout = () => (
  <div className="font-josefine bg-milani-light100 dark:bg-milani-dark100">
    <Outlet />
  </div>
);
export { AppLayout };
